import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { GestorContenidoService } from 'src/app/services/gestor-contenido.service';

@Component({
    selector: 'app-noticias',
    templateUrl: './noticias.component.html',
    styles: [],
    standalone: false
})
export class NoticiasComponent implements OnInit {
  listaNoticias: any[] = [];
  listaAutores: any[] = [];
  listaEtiquetas: any[] = [];
  noticiasForm: UntypedFormGroup;
  noticiasPorFila: number = 3;
  filtroCategorias: any[] = [];
  filtroAutores: any[] = [];
  filtroEtiquetas: any[] = []
  constructor(private formBuilder: UntypedFormBuilder,
    private _gestorContenido: GestorContenidoService) {
    window.scroll(0, 0);
    this.noticiasForm = this.formBuilder.group({
      idNodo: null,
      titulo: '',
      body: '',
      etiquetas: '',
      categorias: '',
      usuario: '',
      fechaMax: '',
      fechaMin: '',
      pagina: null,
    });
  }

  ngOnInit(): void {
    this.getNoticiasPorFiltros();
    this.getAutores();
    this.getEtiquetas();
  }

  getNoticiasPorFiltros() {
    this.listaNoticias = [];
    this._gestorContenido.getNoticiasPorFiltros(this.noticiasForm.value).subscribe(
      (response: any) => {
        const page = response;
        for (let i = 0; i < page.rows.length; i += this.noticiasPorFila) {
          const fila = page.rows.slice(i, i + this.noticiasPorFila);
          this.listaNoticias.push(fila);
        }
      },
      (error) => {

      }
    );
  }

  getAutores() {
    this._gestorContenido.getAutores().subscribe(
      (response: any) => {
        const page = response;
        this.listaAutores = page.data;
      },
      (error) => {
      }
    );
  }

  getEtiquetas() {
    this._gestorContenido.getEtiquetas().subscribe(
      (response: any) => {
        const page = response;
        this.listaEtiquetas = page.data;
      },
      (error) => {
      }
    );
  }

  checkedCategorias(event, name) {
    if (event.target.checked) {
      this.filtroCategorias.push(name)
    } else {
      this.filtroCategorias.splice(this.filtroCategorias.find(item => item.value === name), 1);
    }
  }

  checkedAutores(event, name) {
    if (event.target.checked) {
      this.filtroAutores.push(name)
    } else {
      this.filtroAutores.splice(this.filtroAutores.find(item => item.value === name), 1);
    }
  }

  checkedEtiquetas(event, name) {
    if (event.target.checked) {
      this.filtroEtiquetas.push(name)
    } else {
      this.filtroEtiquetas.splice(this.filtroEtiquetas.find(item => item.value === name), 1);
    }
  }

  filtro() {
    const stringCategorias = this.filtroCategorias.join(', ');
    this.noticiasForm.get("categorias").setValue(stringCategorias);
    const stringAutores = this.filtroAutores.join(', ');
    this.noticiasForm.get("usuario").setValue(stringAutores);
    const stringEtiquetas = this.filtroEtiquetas.join(', ');
    this.noticiasForm.get("etiquetas").setValue(stringEtiquetas);
    this.getNoticiasPorFiltros();
  }

  transformarTitulo(titulo: string){
    return titulo.replace(/ /g, '_');
  }
}